var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.value ? _c('div', {
    staticClass: "alarm-notifications"
  }, [_c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask d-flex align-items-center justify-content-center",
    on: {
      "click": function ($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.handleClickOutside.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog w-100",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content fixed-size-modal"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t("Notifications")))]), _vm.settingsLink ? _c('router-link', {
    staticClass: "settings-link ml-auto",
    attrs: {
      "to": _vm.settingsLink,
      "title": _vm.$t('alarm_notifications.title'),
      "aria-label": _vm.$t('alarm_notifications.title')
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.close.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-gear"
  })]) : _vm._e(), _c('button', {
    staticClass: "close",
    class: {
      'ml-3': _vm.settingsLink
    },
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.close.apply(null, arguments);
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])], 1), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [!_vm.selectedAlarm ? [_c('div', {
    staticClass: "filters"
  }, [_c('div', {
    staticClass: "form-group search-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchQuery,
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('notifications.search_location').toString()
    },
    domProps: {
      "value": _vm.searchQuery
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.searchQuery = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "form-group type-dropdown"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedType,
      expression: "selectedType"
    }],
    staticClass: "form-control type-dropdown",
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.selectedType = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("notifications.all_alarms")) + " ")]), _vm._l(_vm.alarmTypes, function (type) {
    return _c('option', {
      key: type,
      domProps: {
        "value": type
      }
    }, [_vm._v(" " + _vm._s(_vm.alarmTypeTitle(type)) + " ")]);
  })], 2), _c('span', {
    staticClass: "alarm-count"
  }, [_vm._v(_vm._s(_vm.alarmCount))])]), _c('div', {
    staticClass: "level-filter"
  }, _vm._l(_vm.availableLevels, function (level) {
    return _c('AlarmLevelBadge', {
      key: level,
      attrs: {
        "level": level,
        "active": _vm.isLevelSelected(level),
        "interactive": ""
      },
      on: {
        "click": function ($event) {
          return _vm.toggleLevel(level);
        }
      }
    });
  }), 1)]), _c('div', {
    staticClass: "content"
  }, [_vm.filteredNotifications.length > 0 ? _c('div', _vm._l(_vm.filteredNotifications, function (alarm) {
    var _alarm$deviceName, _alarm$locationName;
    return _c('div', {
      key: alarm.id,
      staticClass: "card alarm-card",
      on: {
        "click": function ($event) {
          return _vm.openAlarmDetail(alarm);
        }
      }
    }, [_c('div', {
      staticClass: "card-body d-flex align-items-stretch"
    }, [_c('div', {
      staticClass: "alarm-card-main flex-grow-1"
    }, [_c('div', {
      staticClass: "alarm-header"
    }, [_c('AlarmLevelIcon', {
      attrs: {
        "level": alarm.level
      }
    }), _c('span', {
      staticClass: "alarm-title"
    }, [_vm._v(_vm._s(_vm.alarmTypeTitle(alarm.type)))]), _c('div', {
      staticClass: "alarm-detail-row alarm-header-time"
    }, [_c('i', {
      staticClass: "fa-solid fa-calendar-days"
    }), _c('span', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        value: _vm.formatDate(alarm.conditionStartedAt, false),
        expression: "\n                                                                formatDate(\n                                                                    alarm.conditionStartedAt,\n                                                                    false,\n                                                                )\n                                                            ",
        modifiers: {
          "hover": true
        }
      }]
    }, [_vm._v(_vm._s(_vm.formatDate(alarm.conditionStartedAt)))])])], 1), alarm.deviceName ? _c('div', {
      staticClass: "alarm-detail-row"
    }, [_c('i', {
      staticClass: "fa-solid fa-plug-circle-xmark"
    }), _c('span', [_vm._v(_vm._s((_alarm$deviceName = alarm.deviceName) !== null && _alarm$deviceName !== void 0 ? _alarm$deviceName : "-"))])]) : _vm._e(), alarm.locationName ? _c('div', {
      staticClass: "alarm-detail-row"
    }, [_c('i', {
      staticClass: "fa-solid fa-house"
    }), _c('span', [_vm._v(_vm._s((_alarm$locationName = alarm.locationName) !== null && _alarm$locationName !== void 0 ? _alarm$locationName : "-"))])]) : _vm._e()]), _c('i', {
      staticClass: "fa-solid fa-chevron-right alarm-chevron align-self-center"
    })])]);
  }), 0) : _c('span', {
    staticClass: "text-center text-info no-alarms"
  }, [_vm._v(_vm._s(_vm.$t("notifications.no_alarms")))])])] : _c('AlarmDetail', {
    attrs: {
      "alarm": _vm.selectedAlarm
    },
    on: {
      "close": _vm.closeAlarmDetail
    }
  })], 2)])])])])], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }